export const Validation = {
    REQUIRED: 'Please enter',
}